/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import {
	GA4_EVENT_LOGIN_OPEN_LOGIN,
	GA4_EVENT_LOGIN_OPEN_REGISTER,
	LOGIN_OPEN_LOGIN,
	LOGIN_OPEN_REGISTER,
	PAGE_DATA_LAYER,
} from '@/data/constants/gtm';
import { getGTMLoginOpenEventData } from '@/data/events/data/gtm/LoginOpen';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMLoginOpenPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

const resolveEventName = (flow: GTMLoginOpenPayload['flow'], variant: 'ga4' | 'ua') => {
	if (variant === 'ga4') {
		return flow === 'register' ? GA4_EVENT_LOGIN_OPEN_REGISTER : GA4_EVENT_LOGIN_OPEN_LOGIN;
	}
	return flow === 'register' ? LOGIN_OPEN_REGISTER : LOGIN_OPEN_LOGIN;
};

export const measure_GA4 = async (
	flow: GTMLoginOpenPayload['flow'],
	data: ReturnType<typeof getGTMLoginOpenEventData>
) => {
	const dataLayerName = PAGE_DATA_LAYER;
	TagManager.dataLayer({
		dataLayer: { event: resolveEventName(flow, 'ga4'), ...data },
		dataLayerName,
	});
};

export const measure_UA = async (
	flow: GTMLoginOpenPayload['flow'],
	data: ReturnType<typeof getGTMLoginOpenEventData>
) => {
	const dataLayerName = PAGE_DATA_LAYER;
	TagManager.dataLayer({
		dataLayer: { event: resolveEventName(flow, 'ua'), ...data },
		dataLayerName,
	});
};

export const sendGTMLoginOpenEvent = async (payload: GTMLoginOpenPayload) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = getGTMLoginOpenEventData(payload);
		if (ua) {
			try {
				await measure_UA(payload.flow, data);
			} catch (error) {
				logError(undefined, 'LoginOpen: sendGTMLoginOpenEvent: measure_UA: error: %o', error);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(payload.flow, data);
			} catch (error) {
				logError(undefined, 'LoginOpen: sendGTMLoginOpenEvent: measure_GA4: error: %o', error);
			}
		}
	}
};
